import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fb04d810"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "js-page-content",
  role: "main",
  class: "page-content"
}
const _hoisted_2 = { class: "subheader d-block d-md-flex" }
const _hoisted_3 = { class: "subheader-title mb-2 mb-md-0" }
const _hoisted_4 = { class: "d-block d-md-flex mr-0 justify-content-md-end" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<option value=\"2023\" data-v-fb04d810>2023年度</option><option value=\"2024\" data-v-fb04d810>2024年度</option><option value=\"2025\" data-v-fb04d810>2025年度</option><option value=\"2026\" data-v-fb04d810>2026年度</option><option value=\"2027\" data-v-fb04d810>2027年度</option><option value=\"2028\" data-v-fb04d810>2028年度</option><option value=\"2029\" data-v-fb04d810>2029年度</option>", 7)
const _hoisted_13 = [
  _hoisted_6
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "vr mr-2 mb-2 align-self-center" }, null, -1))
const _hoisted_15 = ["disabled"]
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["disabled"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fal fa-reply mr-1" }, null, -1))
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-sm-6 col-xl-3" }
const _hoisted_21 = { class: "p-3 bg-primary-300 rounded overflow-hidden position-relative text-white mb-g" }
const _hoisted_22 = { class: "" }
const _hoisted_23 = { class: "display-4 d-block l-h-n m-0 fw-500" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "m-0 l-h-n" }, "受注売上額", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fal fa-yen-sign position-absolute pos-right pos-bottom opacity-15 mb-n1 mr-n1",
  style: {"font-size":"6rem"}
}, null, -1))
const _hoisted_26 = { class: "col-sm-6 col-xl-3" }
const _hoisted_27 = { class: "p-3 bg-primary-300 rounded overflow-hidden position-relative text-white mb-g" }
const _hoisted_28 = { class: "" }
const _hoisted_29 = { class: "display-4 d-block l-h-n m-0 fw-500" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "m-0 l-h-n" }, "受注仕入額", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fal fa-yen-sign position-absolute pos-right pos-bottom opacity-15 mb-n1 mr-n1",
  style: {"font-size":"6rem"}
}, null, -1))
const _hoisted_32 = { class: "col-sm-6 col-xl-3" }
const _hoisted_33 = { class: "p-3 bg-primary-300 rounded overflow-hidden position-relative text-white mb-g" }
const _hoisted_34 = { class: "" }
const _hoisted_35 = { class: "display-4 d-block l-h-n m-0 fw-500" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "m-0 l-h-n" }, "受注利益額", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fal fa-yen-sign position-absolute pos-right pos-bottom opacity-15 mb-n1 mr-n1",
  style: {"font-size":"6rem"}
}, null, -1))
const _hoisted_38 = { class: "col-sm-6 col-xl-3" }
const _hoisted_39 = { class: "p-3 bg-primary-300 rounded overflow-hidden position-relative text-white mb-g" }
const _hoisted_40 = { class: "" }
const _hoisted_41 = { class: "display-4 d-block l-h-n m-0 fw-500" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "m-0 l-h-n" }, "受注利益率", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fal fa-yen-sign position-absolute pos-right pos-bottom opacity-15 mb-n1 mr-n1",
  style: {"font-size":"6rem"}
}, null, -1))
const _hoisted_44 = { class: "col-sm-6 col-xl-3" }
const _hoisted_45 = { class: "p-3 bg-success-300 rounded overflow-hidden position-relative text-white mb-g" }
const _hoisted_46 = { class: "" }
const _hoisted_47 = { class: "display-4 d-block l-h-n m-0 fw-500" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "m-0 l-h-n" }, "確定売上額", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fal fa-gem position-absolute pos-right pos-bottom opacity-15 mb-n1 mr-n4",
  style: {"font-size":"6rem"}
}, null, -1))
const _hoisted_50 = { class: "col-sm-6 col-xl-3" }
const _hoisted_51 = { class: "p-3 bg-success-300 rounded overflow-hidden position-relative text-white mb-g" }
const _hoisted_52 = { class: "" }
const _hoisted_53 = { class: "display-4 d-block l-h-n m-0 fw-500" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "m-0 l-h-n" }, "確定仕入額", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fal fa-gem position-absolute pos-right pos-bottom opacity-15 mb-n1 mr-n4",
  style: {"font-size":"6rem"}
}, null, -1))
const _hoisted_56 = { class: "col-sm-6 col-xl-3" }
const _hoisted_57 = { class: "p-3 bg-success-300 rounded overflow-hidden position-relative text-white mb-g" }
const _hoisted_58 = { class: "" }
const _hoisted_59 = { class: "display-4 d-block l-h-n m-0 fw-500" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "m-0 l-h-n" }, "確定利益額", -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fal fa-gem position-absolute pos-right pos-bottom opacity-15 mb-n1 mr-n4",
  style: {"font-size":"6rem"}
}, null, -1))
const _hoisted_62 = { class: "col-sm-6 col-xl-3" }
const _hoisted_63 = { class: "p-3 bg-success-300 rounded overflow-hidden position-relative text-white mb-g" }
const _hoisted_64 = { class: "" }
const _hoisted_65 = { class: "display-4 d-block l-h-n m-0 fw-500" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "m-0 l-h-n" }, "確定利益率", -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fal fa-gem position-absolute pos-right pos-bottom opacity-15 mb-n1 mr-n4",
  style: {"font-size":"6rem"}
}, null, -1))
const _hoisted_68 = { class: "row" }
const _hoisted_69 = { class: "col-xl-12" }
const _hoisted_70 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel-hdr" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "売上詳細"),
  /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-collapse",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Collapse"
    }),
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-fullscreen",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Fullscreen"
    })
  ])
], -1))
const _hoisted_72 = {
  class: "panel-container show",
  id: "panel-2100_summary-graph"
}
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
], -1))
const _hoisted_74 = { class: "panel-content contents" }
const _hoisted_75 = { class: "row" }
const _hoisted_76 = { class: "col-lg-5" }
const _hoisted_77 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel-hdr" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "構成割合"),
  /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-collapse",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Collapse"
    }),
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-fullscreen",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Fullscreen"
    })
  ])
], -1))
const _hoisted_79 = {
  class: "panel-container show",
  id: "panel-2200_ratio-graph"
}
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
], -1))
const _hoisted_81 = { class: "panel-content border-faded border-left-0 border-right-0 border-top-0 text-muted d-flex" }
const _hoisted_82 = { class: "panel-content contents" }
const _hoisted_83 = { class: "col-lg-7" }
const _hoisted_84 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel-hdr" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "売上先別売上額"),
  /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-collapse",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Collapse"
    }),
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-fullscreen",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Fullscreen"
    })
  ])
], -1))
const _hoisted_86 = {
  class: "panel-container show",
  id: "panel-2300_client_graph"
}
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
], -1))
const _hoisted_88 = { class: "panel-content" }
const _hoisted_89 = { class: "row" }
const _hoisted_90 = { class: "col-xl-12" }
const _hoisted_91 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_92 = { class: "panel-hdr" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "担当案件一覧", -1))
const _hoisted_94 = { class: "panel-toolbar" }
const _hoisted_95 = { class: "m-0" }
const _hoisted_96 = { class: "badge badge-pill badge-info fw-400 l-h-n" }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-panel",
  "data-action": "panel-collapse",
  "data-toggle": "tooltip",
  "data-offset": "0,10",
  "data-original-title": "Collapse"
}, null, -1))
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-panel",
  "data-action": "panel-fullscreen",
  "data-toggle": "tooltip",
  "data-offset": "0,10",
  "data-original-title": "Fullscreen"
}, null, -1))
const _hoisted_99 = {
  class: "panel-container show",
  id: "panel-2400_list"
}
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
], -1))
const _hoisted_101 = { class: "panel-content" }
const _hoisted_102 = {
  key: 0,
  class: "gtablecell btnDetCell"
}
const _hoisted_103 = ["onClick"]
const _hoisted_104 = { key: 1 }
const _hoisted_105 = { key: 2 }
const _hoisted_106 = { key: 3 }
const _hoisted_107 = { key: 4 }
const _hoisted_108 = {
  key: 5,
  class: "gtablecell"
}
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times-circle text-danger mr-2" }, null, -1))
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_111 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Mo_chart_barline = _resolveComponent("Mo_chart_barline")!
  const _component_Mo_chart_doughnut = _resolveComponent("Mo_chart_doughnut")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!
  const _component_Mo_modal_alert = _resolveComponent("Mo_modal_alert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("main", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.delegate.dataStaff.c_staff_name) + "さんの個人分析 ", 1),
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("select", {
            class: "mr-2",
            style: {"border":"1px solid #ddd","height":"40px","border-radius":"5px","min-width":"100px","text-align":"center"},
            disabled: _ctx.btnDisable,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.domBisYear) = $event))
          }, _hoisted_13, 8, _hoisted_5), [
            [_vModelSelect, _ctx.domBisYear]
          ]),
          _hoisted_14,
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-success waves-effect waves-themed mr-2 mb-2",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.get4All())),
            disabled: _ctx.btnDisable
          }, " 再読み込み ", 8, _hoisted_15),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-success waves-effect waves-themed mr-2 mb-2",
            disabled: _ctx.btnDisable
          }, " レポート出力 ", 8, _hoisted_16),
          _createElementVNode("button", {
            disabled: _ctx.btnDisable,
            type: "button",
            class: "btn btn-secondary waves-effect waves-themed mr-2 mb-2",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/analyprofit2')))
          }, [
            _hoisted_18,
            _createTextVNode("戻る ")
          ], 8, _hoisted_17)
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("h3", _hoisted_23, [
                _createTextVNode(" ¥" + _toDisplayString(_ctx.delegate.badge_20001_sales_order.toLocaleString("ja-JP")) + "- ", 1),
                _hoisted_24
              ])
            ]),
            _hoisted_25
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("h3", _hoisted_29, [
                _createTextVNode(" ¥" + _toDisplayString(_ctx.delegate.badge_20002_supply_order.toLocaleString("ja-JP")) + "- ", 1),
                _hoisted_30
              ])
            ]),
            _hoisted_31
          ])
        ]),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("h3", _hoisted_35, [
                _createTextVNode(" ¥" + _toDisplayString(_ctx.delegate.badge_20003_profit_order.toLocaleString("ja-JP")) + "- ", 1),
                _hoisted_36
              ])
            ]),
            _hoisted_37
          ])
        ]),
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("h3", _hoisted_41, [
                _createTextVNode(_toDisplayString(_ctx.delegate.badge_20004_ratio_profit_order) + "% ", 1),
                _hoisted_42
              ])
            ]),
            _hoisted_43
          ])
        ]),
        _createElementVNode("div", _hoisted_44, [
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("h3", _hoisted_47, [
                _createTextVNode(" ¥" + _toDisplayString(_ctx.delegate.badge_20005_sales.toLocaleString("ja-JP")) + "- ", 1),
                _hoisted_48
              ])
            ]),
            _hoisted_49
          ])
        ]),
        _createElementVNode("div", _hoisted_50, [
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("h3", _hoisted_53, [
                _createTextVNode(" ¥" + _toDisplayString(_ctx.delegate.badge_20006_supply.toLocaleString("ja-JP")) + "- ", 1),
                _hoisted_54
              ])
            ]),
            _hoisted_55
          ])
        ]),
        _createElementVNode("div", _hoisted_56, [
          _createElementVNode("div", _hoisted_57, [
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("h3", _hoisted_59, [
                _createTextVNode(" ¥" + _toDisplayString(_ctx.delegate.badge_20007_profit.toLocaleString("ja-JP")) + "- ", 1),
                _hoisted_60
              ])
            ]),
            _hoisted_61
          ])
        ]),
        _createElementVNode("div", _hoisted_62, [
          _createElementVNode("div", _hoisted_63, [
            _createElementVNode("div", _hoisted_64, [
              _createElementVNode("h3", _hoisted_65, [
                _createTextVNode(_toDisplayString(_ctx.delegate.badge_20008_ratio_profit) + "% ", 1),
                _hoisted_66
              ])
            ]),
            _hoisted_67
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_68, [
        _createElementVNode("div", _hoisted_69, [
          _createElementVNode("div", _hoisted_70, [
            _hoisted_71,
            _createElementVNode("div", _hoisted_72, [
              _hoisted_73,
              _createElementVNode("div", _hoisted_74, [
                (_ctx.reRender)
                  ? (_openBlock(), _createBlock(_component_Mo_chart_barline, {
                      key: 0,
                      chartData: _ctx.delegate.summary_graph_2100_chartData,
                      options: _ctx.chartOptions4d2
                    }, null, 8, ["chartData", "options"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_75, [
        _createElementVNode("div", _hoisted_76, [
          _createElementVNode("div", _hoisted_77, [
            _hoisted_78,
            _createElementVNode("div", _hoisted_79, [
              _hoisted_80,
              _createElementVNode("div", _hoisted_81, [
                _createVNode(_component_Mo_chart_doughnut, {
                  style: {"width":"100%","max-height":"230px"},
                  chartData: _ctx.delegate.client_graph_22001_chartData,
                  options: _ctx.chartOptions4d1
                }, null, 8, ["chartData", "options"])
              ]),
              _createElementVNode("div", _hoisted_82, [
                _createVNode(_component_Mo_chart_doughnut, {
                  style: {"width":"100%"},
                  chartData: _ctx.delegate.client_graph_22002_chartData,
                  options: _ctx.chartOptions4d1
                }, null, 8, ["chartData", "options"])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_83, [
          _createElementVNode("div", _hoisted_84, [
            _hoisted_85,
            _createElementVNode("div", _hoisted_86, [
              _hoisted_87,
              _createElementVNode("div", _hoisted_88, [
                (_ctx.reRender)
                  ? (_openBlock(), _createBlock(_component_Mo_chart_barline, {
                      key: 0,
                      style: {"min-height":"665px"},
                      chartData: _ctx.delegate.client_graph_23001_chartData,
                      options: _ctx.chartOptions4GenreGraph400
                    }, null, 8, ["chartData", "options"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_89, [
        _createElementVNode("div", _hoisted_90, [
          _createElementVNode("div", _hoisted_91, [
            _createElementVNode("div", _hoisted_92, [
              _hoisted_93,
              _createElementVNode("div", _hoisted_94, [
                _createElementVNode("h5", _hoisted_95, [
                  _createElementVNode("span", _hoisted_96, " 担当受注数：" + _toDisplayString(_ctx.delegate.project_list_2400.length) + "件 ", 1)
                ]),
                _hoisted_97,
                _hoisted_98
              ])
            ]),
            _createElementVNode("div", _hoisted_99, [
              _hoisted_100,
              _createElementVNode("div", _hoisted_101, [
                _createVNode(_component_vue_good_table, {
                  columns: _ctx.columns,
                  rows: _ctx.delegate.project_list_2400,
                  "sort-options": {
                  enabled: false,
                },
                  "pagination-options": {
                  enabled: false,
                },
                  totalRows: _ctx.delegate.project_list_2400.length
                }, {
                  "table-row": _withCtx((props) => [
                    (props.column.field == '詳細ボタン')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-xs btn-block btn-primary waves-effect waves-themed",
                            onClick: ($event: any) => (
                        _ctx.goTo(
                          '/jyutyuinput?record_id=' + props.row.c_project_id,
                          $event
                        )
                      )
                          }, " 詳細 ", 8, _hoisted_103)
                        ]))
                      : (props.column.field == 'c_agg_pro_year')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_104, _toDisplayString(_ctx.getYearMonth(props.row)), 1))
                        : (props.column.field == 'c_agg_pro_amount_sales')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_105, _toDisplayString(props.formattedRow[props.column.field].toLocaleString(
                        "ja-JP"
                      )), 1))
                          : (props.column.field == 'c_agg_pro_amount_supply')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_106, _toDisplayString(props.formattedRow[props.column.field].toLocaleString(
                        "ja-JP"
                      )), 1))
                            : (props.column.field == 'c_agg_pro_amount_profit')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_107, _toDisplayString(props.formattedRow[props.column.field].toLocaleString(
                        "ja-JP"
                      )), 1))
                              : (_openBlock(), _createElementBlock("div", _hoisted_108, _toDisplayString(props.formattedRow[props.column.field]), 1))
                  ]),
                  _: 1
                }, 8, ["columns", "rows", "totalRows"])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Mo_modal_alert, { ref: "Mo_modal_errorConf" }, {
      title: _withCtx(() => [
        _hoisted_109,
        _createTextVNode(_toDisplayString(_ctx.message4ModalErrorConf), 1)
      ]),
      body: _withCtx(() => [
        _hoisted_110
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_111, [
          _createElementVNode("button", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.closeModal4ErrorConf())),
            type: "button",
            class: "btn btn-default bootbox-cancel"
          }, " 確認 ")
        ])
      ]),
      _: 1
    }, 512)
  ], 64))
}